import React, {useState} from 'react';
import "../../../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import TableRows from "./TableRows";
import { Link } from 'react-router-dom';
import { useHistory } from 'react-router';

import Header_admin from '../../../Layout/Header_admin';
import Footer_admin from '../../../Layout/Footer_admin';

import { luwjistik_order } from '../../../Context/actions';

import LoadingBar from 'react-top-loading-bar';


function Add_order() {
    const history = useHistory();
    
    const [loading, setLoading] = useState(false);
    const [progress, setProgress] = useState(0);

    const [orderCode, setOrderCode] = useState();
    const [length, setLength] = useState();
    const [width, setWidth] = useState();
    const [height, setHeight] = useState();
    const [weight, setWeight] = useState();
    const [senderName, setSenderName] = useState();
    const [senderEmail, setSenderEmail] = useState();
    const [senderContactNumber, setSenderContactNumber] = useState();
    const [senderState, setSenderState] = useState();
    const [senderCity, setSenderCity] = useState();
    const [senderProvince, setSenderProvince] = useState();
    const [senderPostalCode, setSenderPostalCode] = useState();
    const [senderCountryCode, setSenderCountryCode] = useState();
    const [senderAddress, setSenderAddress] = useState();
    const [FForiginPortCode, setFFOriginPortCode] = useState();
    const [FFdestinationPortCode, setFFdestinationPortCode] = useState();
    const [CCportCode, setCCportCode] = useState();
    const [CCincoterm, setCCincoterm] = useState();
    const [consigneeName, setConsigneeName] = useState();
    const [consigneeContactNumber, setConsigneeContactNumber] = useState();
    const [consigneeAddress, setConsigneeAddress] = useState();
    const [consigneePostalCode, setConsigneePostalCode] = useState();
    const [consigneeCountryCode, setConsigneeCountryCode] = useState();
    const [consigneeCity, setConsigneeCity] = useState();
    const [consigneeProvince, setConsigneeProvince] = useState();
    const [consigneeState, setConsigneeState] = useState();
    const [consigneeEmail, setConsigneeEmail] = useState();

    const [rowsData, setRowsData] = useState([]);
 
    const addTableRows = ()=>{
  
        const rowsInput={
            description:'',
            quantity:'',
            product_code:'',
            sku:'',
            category:'',
            declared_value:'',
            declared_value_currency:''
        } 
        setRowsData([...rowsData, rowsInput])
      
    }
    const deleteTableRows = (index)=>{
        const rows = [...rowsData];
        rows.splice(index, 1);
        setRowsData(rows);
    }
 
    const handleChange = (index, evnt)=>{
        const { name, value } = evnt.target;
        const rowsInput = [...rowsData];
        rowsInput[index][name] = value;
        setRowsData(rowsInput);
    }

    function simpan(){
      setSenderName('ATHA EXPRESS');
      setSenderEmail('atha@gmail.com')
      setSenderContactNumber('083833555600');
      setSenderState('KALIBATA');
      setSenderCity('JAKARTA');
      setSenderProvince('JAKARTA');
      setSenderPostalCode('12740');
      setSenderCountryCode('ID');
      setSenderAddress('KALIBATA TIMUR I NO 19');

      setProgress(progress + 40)
      setLoading(true)

      const promise1 = Promise.resolve(luwjistik_order(orderCode,length,width,height,weight,senderName,senderEmail,senderContactNumber,senderState,senderCity,senderProvince,senderPostalCode,senderCountryCode,senderAddress,FForiginPortCode,FFdestinationPortCode,CCportCode,CCincoterm,consigneeName,consigneeContactNumber,consigneeAddress,consigneePostalCode,consigneeCountryCode,consigneeCity,consigneeProvince,consigneeState,consigneeEmail,rowsData));
      promise1.then((value) => {
        console.log(value.hasil);
        if(value.hasil == '1'){
            //sukses
            setProgress(100);
            setLoading(false);
            alert(value.message);
            history.push('/luwjistik_order');
            window.location.reload(true);
        }else if(value.hasil == '2'){
            //username password salah
            setProgress(100);
            setLoading(false);
            alert(value.message);
        }
      });
    }
   

    

    const style_pembatas = {
      color: "#061C54",
      fontStyle: "bold"
     };

     const form_order = {
      color: "#061C54",
      fontStyle: "bold"
     };

  return (
    <div>
        <LoadingBar
          color='#f11946'
          progress={progress}
          onLoaderFinished={() => setProgress(0)}
        />
        <Header_admin></Header_admin>
        <main id="main" class="main">

          <div class="pagetitle">
            <h1>Luwjistik Order &nbsp; <img src={require('../../../assets_landingpage/img/luwjistik_icon.png')} alt="Profile" width="100px" height="50px" /></h1>
            <br />
            <nav>
              <ol class="breadcrumb">
                <li class="breadcrumb-item"><Link to="/dashboard">Home</Link></li>
                <li class="breadcrumb-item active">Luwjistik Order</li>
              </ol>
            </nav>
          </div>

          <section class="section">
          <div class="row">
    <div class="col-lg-12">

      <div class="card">
        <div class="card-body">
            <div class="row mb-3 align-items-center">
              <h4 style={style_pembatas}>Form Create Order</h4>
            </div>
            <div class="row mb-3">
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-4">
                      <label>Order Code</label>
                    </div>
                    <div class="col-md-8">
                      <input type="text" id="order_code" name="order_code" onChange={(e) => setOrderCode(e.target.value)} class="form-control" />
                    </div>
                  </div>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-4">
                      <label>Length</label>
                    </div>
                    <div class="col-md-8">
                      <input type="text" id="length" name="length" onChange={(e) => setLength(e.target.value)} class="form-control" />
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                    <div class="row">
                      <div class="col-md-4">
                      <label>Height</label>
                      </div>
                      <div class="col-md-8">
                        <input type="number" id="height" name="height" onChange={(e) => setHeight(e.target.value)} class="form-control" />
                      </div>
                    </div>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-4">
                      <label>Width</label>
                    </div>
                    <div class="col-md-8">
                      <input type="number" id="width" name="width" onChange={(e) => setWidth(e.target.value)} class="form-control" />
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                    <div class="row">
                      <div class="col-md-4">
                        <label>Weight</label>
                      </div>
                      <div class="col-md-8">
                        <input type="number" id="weight" name="weight" onChange={(e) => setWeight(e.target.value)} class="form-control" />
                      </div>
                    </div>
                </div>
            </div>
            <div class="row mb-3 align-items-center">
              <h4 style={style_pembatas}>Freight Forwarding & Custom Clearance</h4>
            </div>
            <div class="row mb-3">
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-4">
                      <label>Origin Port Code</label>
                    </div>
                    <div class="col-md-8">
                      <input type="text" id="freightforwarding_origin_port_code" name="freightforwarding_origin_port_code" onChange={(e) => setFFOriginPortCode(e.target.value)} class="form-control" />
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                    <div class="row">
                      <div class="col-md-4">
                      <label>Port Code (Custom Clearance)</label>
                      </div>
                      <div class="col-md-8">
                        <input type="text" id="customs_clearance_port_code" name="customs_clearance_port_code" onChange={(e) => setCCportCode(e.target.value)} class="form-control" />
                      </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-4">
                      <label>Destination Port Code</label>
                    </div>
                    <div class="col-md-8">
                      <input type="text" id="freightforwarding_destination_port_code" name="freightforwarding_destination_port_code" onChange={(e) => setFFdestinationPortCode(e.target.value)} class="form-control" />
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                    <div class="row">
                      <div class="col-md-4">
                        <label>Incoterm (Custom Clearance)</label>
                      </div>
                      <div class="col-md-8">
                      <input type="text" id="customs_clearance_incoterm" name="customs_clearance_incoterm" onChange={(e) => setCCincoterm(e.target.value)} class="form-control" />
                      </div>
                    </div>
                </div>
            </div>
            
            <div class="row mb-3 align-items-center">
              <h4 style={style_pembatas}>Consignee</h4>
            </div>
            <div class="row mb-3">
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-4">
                      <label>Name (Consignee)</label>
                    </div>
                    <div class="col-md-8">
                      <input type="text" id="consignee_name" name="consignee_name" onChange={(e) => setConsigneeName(e.target.value)} class="form-control" />
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                    <div class="row">
                      <div class="col-md-4">
                      <label>Country Code (Consignee)</label>
                      </div>
                      <div class="col-md-8">
                        <input type="text" id="consignee_country_code" name="consignee_country_code" onChange={(e) => setConsigneeCountryCode(e.target.value)} class="form-control" />
                      </div>
                    </div>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-4">
                      <label>Contact Number (Consignee)</label>
                    </div>
                    <div class="col-md-8">
                      <input type="text" id="consignee_contact_number" name="consignee_contact_number" onChange={(e) => setConsigneeContactNumber(e.target.value)} class="form-control" />
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                    <div class="row">
                      <div class="col-md-4">
                      <label>City (Consignee)</label>
                      </div>
                      <div class="col-md-8">
                        <input type="text" id="consignee_city" name="consignee_city" onChange={(e) => setConsigneeCity(e.target.value)} class="form-control" />
                      </div>
                    </div>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-4">
                      <label>Address (Consignee)</label>
                    </div>
                    <div class="col-md-8">
                      <input type="text" id="consignee_address" name="consignee_address" onChange={(e) => setConsigneeAddress(e.target.value)} class="form-control" />
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                    <div class="row">
                      <div class="col-md-4">
                      <label>Province (Consignee)</label>
                      </div>
                      <div class="col-md-8">
                        <input type="text" id="consignee_province" name="consignee_province" onChange={(e) => setConsigneeProvince(e.target.value)} class="form-control" />
                      </div>
                    </div>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-4">
                      <label>Postal Code (Consignee)</label>
                    </div>
                    <div class="col-md-8">
                      <input type="text" id="consignee_postal_code" name="consignee_postal_code" onChange={(e) => setConsigneePostalCode(e.target.value)} class="form-control" />
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                    <div class="row">
                      <div class="col-md-4">
                      <label>State (Consignee)</label>
                      </div>
                      <div class="col-md-8">
                        <input type="text" id="consignee_state" name="consignee_state" onChange={(e) => setConsigneeState(e.target.value)} class="form-control" />
                      </div>
                    </div>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-4">
                      <label>Email (Consignee)</label>
                    </div>
                    <div class="col-md-8">
                      <input type="text" id="consignee_email" name="consignee_email" onChange={(e) => setConsigneeEmail(e.target.value)} class="form-control" />
                    </div>
                  </div>
                </div>
            </div>
            <div class="row mb-3 align-items-center">
              <h4 style={style_pembatas}>Item</h4>
            </div>
            <div class="row mb-3 justify-content-center align-items-center">
                <table className="table">
                    <thead>
                    <tr>
                        <th>Tambah Item &nbsp;&nbsp;&nbsp;&nbsp;<button className="btn btn-outline-success" onClick={addTableRows} >+</button></th>
                    </tr>
                    </thead>
                <tbody>
                <TableRows rowsData={rowsData} deleteTableRows={deleteTableRows} handleChange={handleChange} />
                </tbody> 
                </table>
            </div>
            <div class="row mb-3 justify-content-center align-items-center">
              <div class="col-sm-12">
                <button className="button_simpan" disabled={loading} onClick={simpan}>
                  {loading ? (
                    <i
                      className="fa fa-refresh fa-spin"
                      style={{ marginRight: "5px" }}
                    />
                  ):
                  (<i
                    className="fa fa-save"
                    style={{ marginRight: "5px" }}
                  />)} &nbsp;
                  {loading && <span>Harap Tunggu ...</span>}
                  {!loading && <span>Simpan</span>}
                </button>
              </div>
            </div>
        </div>
      </div>

    </div>
  </div>
          </section>

        </main>

        <Footer_admin></Footer_admin>

        
    </div>
  );
}

export default Add_order;